import React from 'react';

const SelectField = ({ field, label, options = [], value, onChange, errors = {}, isAdviceLoading = false, t }) => {
  return (
    <div className="w-full">
      <span className="text-[#414651] text-[14px] sm:text-[16px] block mb-1">{label}</span>
      <div className="relative">
        <select
          className={`border p-2 rounded-md w-full h-10 text-sm outline-none bg-white ${errors[field] ? 'border-red-500' : ''} ${isAdviceLoading ? 'opacity-70' : ''}`}
          value={value || ''}
          onChange={(e) => onChange(field, e.target.value)}
          disabled={isAdviceLoading}
        >
          <option value="" disabled>
            {t ? t('preferences.validation.onlyOne') : 'Select'}
          </option>
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        {errors[field] && (
          <div className="text-red-500 text-[10px] md:text-[12px] ml-2 mt-1">{errors[field]}</div>
        )}
      </div>
    </div>
  );
};

export default SelectField;
